import React, { lazy, memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { UiModal } from 'src/components/UI/modal/UiModal';
import { signInOutSelector } from 'src/pages/Account/Profile/Signin/store/selectors';
import { signInOutSlice } from 'src/pages/Account/Profile/Signin/store/slice';

import styles from 'src/styles/pages/_signin.module.scss';

const SignIn = lazy(() => import('src/pages/Account/Profile/Signin'));

declare global {
  interface Window {
    showLoginModal: (v: boolean) => void; // show login modal from anywhere
  }
}

export const AnywhereLoginModal: React.FC = memo(() => {
  const dispatch = useDispatch();

  useEffect(() => {
    window.spa.showLoginModal = (v = true) => dispatch(signInOutSlice.actions.changeModal(v));
  }, [dispatch]);

  const { modal } = useSelector(signInOutSelector);

  const onHide = useCallback(() => dispatch(signInOutSlice.actions.changeModal(false)), [dispatch]);

  return modal ? (
    <UiModal modalClassName={styles.signInModal} noFooter onHide={onHide}>
      <SignIn />
    </UiModal>
  ) : null;
});
